var render = function render(_c,_vm){return _c('div',{staticClass:"b2b-divider",class:{
  [_vm.data.staticClass]: !!_vm.data.staticClass,
  'b2b-divider--no-margin': _vm.props.noMargin,
}},[((_vm.data.domProps && _vm.data.domProps.textContent))?_c('span',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.data.domProps && _vm.data.domProps.textContent))]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }